import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/",
    component: MainLayout,
    name: "main",
    redirect: "/home",
    meta: {
      title: "首页",
      icon: "home",
    },
    hideChildrenInMenu: true,
    // hidden: true,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/Home"),
        meta: {
          title: "首页",
        },
      },
    ],
  },
];
